// Vue Router 4 -> 현재 라우터에서는 라우터 인스턴스 + 가드만 구성. 
// 실제 라우트 정의는 routes/{auth,main} 도메인 모듈로 분리함.
import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore, jwtExpired } from '@/stores/auth';
import { menuGuard, notFoundGuard } from './guard';
import authRoutes from './routes/auth';
import mainRoutes from './routes/main';

// 라우트 등록
const routes = [
  ...authRoutes,
  ...mainRoutes,
  // 위에서 안 걸린 주소는 안내 후 홈으로(Dashboard -> HOM0010). 화면은 그리지 않는다
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: { render: () => null }, beforeEnter: notFoundGuard },
];

// 라우터 생성
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 라우터 가드 생성(인증 여부 확인) 
router.beforeEach(async (to) => {
  const auth = useAuthStore();
  const requiresAuth = to.matched.some((r) => r.meta.requiresAuth);
  // 토큰 유무만 보면 만료된 토큰이 가드를 통과해 화면이 그려지고 API 만 전부 401 이 된다.
  // 사용자에게는 '로그인이 안 된 것'과 '데이터가 없는 것'이 같은 화면으로 보인다.
  if (requiresAuth && !(await auth.ensureSession())) {
    return { name: 'Login', query: { redirect: to.fullPath } };
  }
  // 로그인 되었는데 로그인화면요청. 만료 토큰까지 '로그인됨'으로 보면 홈으로 튕겼다가
  // 가드가 갱신을 시도하고 실패해 되돌아온다 - 사용자는 멈춘 뒤 엉뚱한 쿼리를 달고 제자리다.
  if (to.name === 'Login' && auth.isLoggedIn && !jwtExpired(auth.accessToken)) {
    return { name: 'Dashboard' };
  }
  if (requiresAuth && auth.isLoggedIn) {  //로그인상태에서 메뉴권한 확인
    const blocked = await menuGuard(to);
    if (blocked !== true) return blocked;
  }
  return true;
});

export default router;
